import { render, staticRenderFns } from "./AmazonConnectPABX.vue?vue&type=template&id=ca5319a4&"
import script from "./AmazonConnectPABX.vue?vue&type=script&lang=js&"
export * from "./AmazonConnectPABX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports